<template>
    <main-section class="main-section--sm">
        <template #tit>
            협력 연구 등을 위해 지역의 대학, 연구소, 진흥원, 센터 등과 <br />
            활발한 교류로 <span class="primary--text">기술력 축적</span> 및 <span class="primary--text">신제품 출시</span>
        </template>

        <v-row justify="space-between" align="center" class="row--lg">
            <v-col v-for="(item, index) in items" :key="index" cols="6" xl="auto">
                <img :src="item.image" alt="" class="product-image" />
                <div class="txt txt--lg grey--text text--darken-4 text-center mt-10px">
                    {{ item.name }}
                </div>
            </v-col>
        </v-row>
    </main-section>
</template>

<script>
import MainSection from "@/components/client/inc/main-section.vue";
import SquareTitle from "../dumb/square-title.vue";

export default {
    components: {
        MainSection,
        SquareTitle,
    },
    data() {
        return {
            items: [
                {
                    name: "아레스 프로틴",
                    image: "/images/main/products/main-product-1.png",
                },
                {
                    name: "프로 17",
                    image: "/images/main/products/main-product-2.png",
                },
                {
                    name: "술애타유",
                    image: "/images/main/products/main-product-3.png",
                },
                {
                    name: "락토펫",
                    image: "/images/main/products/main-product-4.png",
                },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
.main-section {
    background-color: rgba(245, 245, 245, 0.37);
}
.product-image {
    display: block;
    filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.25));
    margin: 0 auto;
}
</style>